<template>
  <v-data-table :headers="headers" :items="disciplinas" :sort-desc="true" class="elevation-1" :search="search">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-progress-circular :size="50" color="green" indeterminate v-if="$store.state.isloading"></v-progress-circular>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>

        <v-divider class="mx-8" inset vertical></v-divider>
        <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.novadescricaoSelecionado }}</strong></span>
        <div class="flex-grow-1"></div>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

        <div>
          <v-row>
            <v-col md="10" class="rigth_container_components">
              <minipauta :turma="$store.state.objturma" :isnota="isNotas" @fecharComponente="fecharTelaComponente" v-if="menuSelected == 1"></minipauta>
            </v-col>
          </v-row>
        </div>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-menu bottom origin="right right" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn dark color="primary" style="color:white;font-size:10px;" v-on="on">Opcções de impressão</v-btn>
        </template>
        <v-list>
          <v-list-item @click=" callDialogMinipauta(item,1)"> <v-icon  class="mr-2" style="color:teal">list</v-icon> <span>Impressão - Com notas</span></v-list-item>
          <v-list-item @click=" callDialogMinipauta(item,0)"> <v-icon  class="mr-2" style="color:#808080">list</v-icon> <span>Impressão - Sem notas</span></v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:no-data> Dados não entontrados! </template>
  </v-data-table>
</template>
<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
import minipauta from './componentes/pauta/mini.vue'
const ls = require('local-storage')
export default {
  components: {
    minipauta
  },
  data: () => ({
    isNotas: 1,
    disciplinas: [],
    search: '',
    menuSelected: 0,
    backTo: null,
    overlay: false,
    headers: [
      {
        text: 'Disciplinas',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Acção', value: 'action', sortable: false,align: 'right' }
    ]

  }),

  computed: {
    idclasse() {
      return this.$store.state.idclasse
    },
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    nivelUsuario() {
      return ls.get('nivel_user')
    }
  },

  created() {
    this.backTo = ls.get('backTo')
    this.disciplinasTurmaAll()
  },

  methods: {
    async disciplinasTurmaAll() {
      try {
        this.$store.state.isloading = true
        let disciplinasAll = await axios.get('/disciplinaTurma/' + ls.get('disciplinasDaTurma').idCurso + '/' + ls.get('disciplinasDaTurma').idclasse).then(res => res.data);

        if (this.nivelUsuario == 6) {
          let disciplinas = ls.get('disciplinasDoProfessor');
          this.disciplinas = disciplinasAll.filter(disciplina => disciplinas.some(disci => disci.iddisciplina == disciplina.iddisciplina));
        } else {
          this.disciplinas = disciplinasAll;
        }
      } catch (error) {
        Swal.fire('Erro', 'Erro ao carregar as disciplinas!', 'error');
      } finally {
        this.$store.state.isloading = false
      }
    },

    callDialogMinipauta(item,isNotas) {
      if(this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      } else {
        this.isNotas = isNotas
        this.$store.state.objturma = item
        this.menuSelected = 1
      }
    },

    
    fecharTelaComponente() {
      this.menuSelected = 0
    }
  }
}
</script>